import { IsNotEmpty, IsString, Length } from 'class-validator';

export class EmailContent {
  @IsString()
  @Length(0, 255)
  subject!: string;

  @IsString()
  @IsNotEmpty()
  text!: string;

  @IsString()
  @IsNotEmpty()
  html!: string;
}
